<template>
	<div class="bg2">
		<!-- <Header title="搜索" background="#ffffff"></Header> -->
		<div class="head" @click='stop'>
			<div class="searchBox">
				<el-input placeholder="请输入想要的商品" clearable v-model="form.condition.content" class="input-with-select">
					<el-select v-model="form.condition.content_type" popper-class="search" slot="prepend"
						@change="change">
						<el-option label="商品" value="1"></el-option>
						<el-option label="链接" value="2"></el-option>
					</el-select>
				</el-input>
				<div class="searchBtn" @click="search(1)">搜索</div>
			</div>
		</div>
		<div class="historyBox" v-if="isSearch">
			<div class="history">
				<p>搜索历史</p>
				<div v-if="historyArr.length>0">
					<span @click="getList(item)" v-for="(item, index) in historyArr" :key="index">
						{{ item }}</span>
				</div>
			</div>
			<div class="history">
				<p>大家都在搜</p>
				<div>
					<span @click="getList(item.content)" v-for="(item, index) in hotRecord" :key="index">
						{{ item.content }}</span>
				</div>
			</div>
		</div>
		<div class="result" v-if="!isSearch">
			<div class="menu flex-between">
				<van-dropdown-menu active-color="#FD0212">
					<van-dropdown-item v-model="form.condition.priceOrder" :options="option1" />
				</van-dropdown-menu>
				<span @click='form.condition.isNew=!form.condition.isNew'
					:class="{active:form.condition.isNew}">新上市</span>
				<div class="flex-center" @click="selectBox = !selectBox">
					<span>筛选</span>
					<!-- <img class="selectImg" src="../../assets/home/shaixuan@2x.png" alt=""> -->
					<img class="selectImg" src="../../assets/home/shaixuan@2x (2).png" alt="" />
				</div>
			</div>
			<div class="simple-scroll-list-out">

				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList"
					class="simple-scroll-list">
					<!-- <simple-scroll-list :finished="finished" @load="getList"> -->
					<van-pull-refresh v-model="isLoading" @refresh="search">
						<router-link :to="`/classify/commodity/details/${item.id}/${item.status}`" class="list"
							v-for="(item,index) in list" :key="index">
							<div class="list">
								<img v-if="item.status == 'sold_out'" src="../../assets/home/sold.png"
									class="soldIcon" />
								<img v-if="item.auction != null" src="../../assets/home/auction.png"
									class="soldIcon" />
								<!-- <img v-lazy="item.thumb" alt="" /> -->
								<img :src="item.thumb" alt="" />
								<h5>{{item.title}}</h5>
								<p>¥{{item.marketPrice}}</p>
							</div>
						</router-link>
					</van-pull-refresh>
					<!-- </simple-scroll-list> -->
				</van-list>

				<!-- <div v-if="selectBox"  @click="selectBox = !selectBox">
			
		</div> -->
				<van-popup v-model="selectBox" position="right" :style="{ height: '100%',width:'76%' }">
					<searchBox :keyword="form.condition.content" :conditionList="conditionList" @newSearch="newSearch" class="mengceng"></searchBox>
				</van-popup>
			</div>
		</div>

	</div>
</template>
<script>
	// import SimpleScrollList from "../../components/SimpleScrollList.vue";
	import searchBox from "./selectBox";
	export default {
		name: "search",
		data() {
			return {
				searchType: 1,
				isLoading: false,
				loading: false,
				finished: false,
				hotRecord: [],
				isNew: false,
				list: [],
				isSearch: true,
				selectBox: false,
				value: "",
				select: "1",
				historyArr: [],
				conditionList: [],
				value1: 0,
				value2: "a",
				option1: [{
						text: "综合",
						value: undefined
					},
					{
						text: "价格降序",
						value: 'down'
					},
					{
						text: "价格升序",
						value: 'up'
					},
				],
				form: {
					lastId: 0, // 必选 最新ID。首次传0，之后传接口返回的lastId
					page: 1, // 必选 请求数据页码
					condition: {
						content_type: "1",
						content: '',

						priceOrder: undefined,
						isNew: false,
						// condition:'',
					}, // 必选 搜索条件
				},
			};
		},
		components: {
			searchBox,
			// SimpleScrollList,
		},
		// beforeRouteLeave(to, from, next) {
		// 	this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
		// 	// 设置下一个路由的 meta
		// 	// console.log(this.scrollTop,333)
		// 	to.meta.keepAlive = false; // 让 A 缓存，即不刷新
			
		// 	if (to.name == 'classifyCommoditydetails') {
		// 		from.meta.keepAlive = true; // 让 A 缓存，即不刷新
		// 			console.log("htestttttttttt")
		// 	} else {
		// 		from.meta.keepAlive = false; // 让 A 缓存，即不刷新
		// 	}
		// 	next();
		// },
		// beforeRouteEnter(to, from, next) {
		// 	if (!sessionStorage.getItem('firstSearch')) {
		// 		to.meta.keepAlive = true; // 让 A 缓存，即不刷新
		// 		sessionStorage.setItem('firstSearch', 'true')
		// 	} else {
		// 		if (from.name == 'classifyCommoditydetails') {
		// 			to.meta.keepAlive = true; // 让 A 缓存，即不刷新
		// 		} else {
		// 			to.meta.keepAlive = false; // 让 A 缓存，即不刷新
		// 		}


		// 	}
		// 	// if(to.name=='details'){
		// 	// 		to.meta.keepAlive = true;  // 让 A 缓存，即不刷新
		// 	// }else{
		// 	// 		to.meta.keepAlive = false;  // 让 A 缓存，即不刷新
		// 	// }
		// 	next(vm => {
		// 		// console.log(vm.scrollTop,444)
		// 		document.body.scrollTop = vm.scrollTop;
		// 	})
		// },
		beforeRouteLeave(to, from, next) {
			this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
			// 设置下一个路由的 meta
			// console.log(this.scrollTop,333)
			// to.meta.keepAlive = false; // 让 A 缓存，即不刷新
			
			from.meta.keepAlive = true; // 让 A 缓存，即不刷新
	
			sessionStorage.setItem('firstSearch', false);
	
			next();
		},
		beforeRouteEnter(to, from, next) {
			to.meta.keepAlive = true; // 让 A 缓存，即不刷新

			if (from.name == 'classifyCommoditydetails' || from.name == 'details_status') {
				sessionStorage.setItem('firstSearch', false);
			}else{
				// if (!sessionStorage.getItem('firstSearch')) {
				sessionStorage.setItem('firstSearch', 'true')
				// }
			}


			// if(to.name=='details'){
			// 		to.meta.keepAlive = true;  // 让 A 缓存，即不刷新
			// }else{
			// 		to.meta.keepAlive = false;  // 让 A 缓存，即不刷新
			// }
			next(vm => {
				// console.log(vm.scrollTop,444)
				document.body.scrollTop = vm.scrollTop;
			})
		},
		computed: {},
		watch: {
			"form.condition.priceOrder"(val) {
				this.form.page = 1
				this.form.lastId = 0
				this.list = []
				this.getList()
			},
			"form.condition.isNew"(val) {
				this.form.page = 1
				this.form.lastId = 0
				this.list = []
				this.getList()
			},
			$route(nVal) {
				console.log(sessionStorage.getItem('firstSearch'))
				if ( sessionStorage.getItem('firstSearch') == "true" ) {
					console.log("htestttttttttt")
					this.isSearch = true
					this.form.condition.content = ""
					this.list = []
					this.form.lastId = 0;
					sessionStorage.setItem('firstSearch', false);

					this.$post({
						url: "/portal/Shop",
						module: "Goods",
						interface: "1100",
					}).then((res) => { //console.log(res,2)
						this.hotRecord = res.hotList
						this.historyArr = res.list
					})
				}
			}
		},
		mounted() {
			if (this.$route.query.id || this.$route.query.keyWords) {
				this.isSearch = false
				this.form.condition.categoryId = this.$route.query.id
				// this.form.condition.content = this.$route.query.keyWords
			} else {
				this.isSearch = true
			}

			// this.getList()
			let arr = JSON.parse(localStorage.getItem("history"));
			if (arr) {
				this.historyArr = arr;
			} else {
				this.historyArr = [];
			}
			this.$post({
				url: "/portal/Shop",
				module: "Goods",
				interface: "1003",
			}).then((res) => { //console.log(res,2)
				this.conditionList = res.conditionList
			})
			this.$post({
				url: "/portal/Shop",
				module: "Goods",
				interface: "1100",
			}).then((res) => { //console.log(res,2)
				this.hotRecord = res.hotList
				this.historyArr = res.list
			})
		},
		methods: {
			change(e) {
				console.log(e);
				this.searchType = e;
			},
			stop() {
				console.log('111')
				this.selectBox = false
			},
			// 点击搜索按钮
			search(type) {
				// let arr = [...this.historyArr];
				// if(!this.value){
				// 		  return;
				// }
				// if(!type&&this.isSearch&&this.form.condition.content_type==1){
				//  if (arr.length) {
				//    arr.unshift(this.value);
				//    let newArr = arr.slice(0, 5);
				//    localStorage.setItem("history", JSON.stringify(newArr));
				//  } else {
				//    arr.unshift(this.value);
				//    localStorage.setItem("history", JSON.stringify(arr));
				//  }
				// }
				// this.form.condition.content = this.value
				// this.historyArr = arr
				// this.list = []
				this.form.lastId = 0;
				this.form.page = 1
				this.getList(this.value)

				this.isSearch = false
			},
			// 下拉刷新
			pullGetList() {
				this.getList()
			},
			getList(content, type) {
				// if (id && floor) {
				//   this.form.page = 1;
				//   this.form.lastId = 0;
				//   this.form.condition.categoryId = id;
				//   this.form.condition.floor = floor;
				//   this.list = [];
				//   this.loading = true;
				//   this.finished = false;
				// }
				if (content) {
					this.form.condition.content = content
				}
				if (this.form.condition.priceOrder) {
					this.form.condition.orderField = 'price'
				} else {
					this.form.condition.orderField = undefined
				}
				// if(this.form.page=1||type==1){
				//  this.list = []
				//  this.form.lastId = 0;
				// }
				// this.$router.push('/search?keyWords='+this.form.condition.content)
				this.finished = true;
				this.$post({
					url: "/portal/Shop",
					module: "Goods",
					interface: "1001",
					data: this.form,
				}).then((res) => {
					if(this.searchType == 1) {
						if (this.form.page > 1) {
							if(res.list) {
								this.list = this.list.concat(res.list);
							}
						} else {
							this.list = res.list
						}
						this.form.lastId = res.lastId;
						console.log(res.list.length >= 1)
						if(res.list.length > 100) {
							this.form.page++;
							if (res.list) {
								this.finished = false;
							}
						}else{
							this.finished = true;
						}
						
						// this.finished = res.currentPage >= res.lastPage;

						
						this.loading = false;
						this.isLoading = false
						if (content) {
							this.isSearch = false
						}
					} else {
						this.list = res.list;
						this.loading = false;
						this.finished = true;
						this.isLoading = false
						// if (content) {
						// 	this.isSearch = false
						// }
					}
					
				});
			},
			newSearch(item) {
				this.$post({
					url: "/portal/Shop",
					module: "Goods",
					interface: "1001",
					data: item,
				}).then((res) => {
					this.list = res.list;
					this.loading = false;
					this.selectBox = false
				});

			}
		},
	};
</script>

<style lang='less' scoped>
    /deep/ .van-overlay {
		z-index: 2000 !important;
	}

	.van-popup {
		z-index: 2001 !important;
	}

	/deep/ .van-pull-refresh__track {
		width: 100%;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		align-items: center;
	}

	/deep/.van-dropdown-menu__bar {
		box-shadow: none;
	}

	.head {
		height: 44px;
		background: #ffffff;
		padding: 0 16px;
	}

	.searchBox {
		display: flex;
		align-items: center;
	}

	/deep/ .el-input-group {
		height: 30px;
		background: #f7f7f7;
		border-radius: 15px;
		width: 80%;
	}

	/deep/ .el-input-group__append,
	/deep/ .el-input-group__prepend {
		background-color: transparent;
		border: none;
		width: 50px;
		padding: 0;
		padding-left: 15px;
	}

	/deep/ .el-input__inner {
		background-color: transparent;
		border: none;
		padding-left: 15px;
	}

	.searchBtn {
		width: 56px;
		height: 30px;
		background: #fd0212;
		border-radius: 15px;
		text-align: center;
		line-height: 30px;
		font-size: 14px;
		color: #ffffff;
		margin-left: 5px;
	}

	.history {
		padding: 0 16px;

		p {
			color: #999999;
			font-size: 12px;
			height: 50px;
			line-height: 50px;
		}

		div {
			display: flex;
			flex-wrap: wrap;

			// justify-content: space-between;
			span {
				padding: 8px 24px;

				background: #ffffff;
				border-radius: 4px;
				border: 1px solid #e5e5e5;
				font-size: 14px;
				margin-right: 15px;
				margin-bottom: 15px;
			}
		}
	}

	.bg2 {
		/* flex-direction: column;
  display: flex;
  height: 100vh; */
	}

	.simple-scroll-list-out {
		position: relative;
		height: calc(100% - 49px);

		.simple-scroll-list {
			padding: 0 16px;
		}

		/deep/.list-inner {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			align-items: center;
		}

		.mengceng {
			position: absolute;
			height: 100%;
			top: 0;
			right: 0;
			/* background-color: rgba(0, 0, 0, 0.55); */
			width: 100%;
		}

		.list {
			font-size: 14px;
			margin-top: 16px;
			position: relative;

			img {
				width: 164px;
				height: 164px;
			}

			.soldIcon {
				position: absolute;
				top: 0;
				left: 0;
				height: 44px;
				width: 44px;
			}

			h5 {
				text-overflow: -o-ellipsis-lastline;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				line-clamp: 2;
				-webkit-box-orient: vertical;
				width: 160px;
				margin-top: 10px;
			}

			p {
				color: #fd0212;
				line-height: 30px;
			}
		}
	}

	.result {
		flex: 1;
		overflow: hidden;

		.menu {
			background-color: #fff;
			border-bottom: 1px solid #f0f0f0;
			padding: 0 30px;

			.active {
				color: #FD0212;
			}
		}
	}

	.selectImg {
		width: 26px;
		height: 26px;
	}
</style>
